import script from "./StaffList.vue?vue&type=script&lang=ts&setup=true"
export * from "./StaffList.vue?vue&type=script&lang=ts&setup=true"

import "./StaffList.vue?vue&type=style&index=0&id=3aba3cfa&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aba3cfa"]])

export default __exports__